module.exports = __webpack_public_path__ + "static/budynek-004401fc590a43069c4edef05da6c092.png";